// src/pages/SorryPage.tsx
import React from "react";

export const SorryPage: React.FC = () => {
  return (
    <div className="p-8">
      <h1>Sorry</h1>
      <p>何度かログインに失敗しました。時間をおいて再度お試しください。</p>
    </div>
  );
};
